var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.0007 47.6666C37.9668 47.6666 47.6673 37.9661 47.6673 25.9999C47.6673 14.0337 37.9668 4.33325 26.0007 4.33325C14.0345 4.33325 4.33398 14.0337 4.33398 25.9999C4.33398 37.9661 14.0345 47.6666 26.0007 47.6666Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9231 33.7566C22.4898 33.7566 22.0781 33.5833 21.7748 33.28L15.6431 27.1483C15.0148 26.52 15.0148 25.48 15.6431 24.8516C16.2715 24.2233 17.3115 24.2233 17.9398 24.8516L22.9231 29.835L34.0598 18.6983C34.6881 18.07 35.7281 18.07 36.3565 18.6983C36.9848 19.3266 36.9848 20.3666 36.3565 20.995L24.0715 33.28C23.7681 33.5833 23.3565 33.7566 22.9231 33.7566Z",
    fill: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/success-tick.a0317f594353798f99a1b9953fd69b4f.svg";
export { ForwardRef as ReactComponent };